import { definedNotNull } from './defined/index.js';
import { isErr, type Result } from './result.js';

export function assertUnreachable(arg: never): never {
  throw new Error(`assertUnreachable should never be called ${JSON.stringify(arg)}`);
}

export function assert(arg: boolean, message?: string): asserts arg {
  if (!arg) {
    throw new Error(definedNotNull(message) ? message : `Expected arg ${arg} to be true.`);
  }
}

export function assertDefined<T>(
  arg: T | null | undefined,
  message?: string,
): asserts arg is NonNullable<T> {
  if (arg === null || arg === undefined) {
    throw new Error(message ?? `assertDefined got non-defined value: ${arg}`);
  }
}

export function assertNonError<T>(arg: Result<T>): asserts arg is T {
  if (isErr(arg)) {
    throw new Error('arg was error');
  }
}
